import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Modal } from 'react-responsive-modal';
import { AuthContext } from '../../navigation/AuthProvider';
import CustomTable from '../Table';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const details = [
  {
    id: 0,
    type: '주문알림',
    count: 0,
  },
  {
    id: 1,
    type: '픽업알림',
    count: 0,
  },
  {
    id: 2,
    type: '일일마감보고',
    count: 0,
  },
];

const OrderTalkModal = ({ isVisible, setVisible }: Props) => {
  const oAuthContext = useContext(AuthContext);

  const onClose = () => {
    setVisible(false);
  };

  //테이블 헤더
  const tableHeader = ['알림종류', '사용건수'];
  const renderTableItem = () => {
    return (
      <>
        {details.map((data: any, index: number) => (
          <tr key={index} className="webTableWrap">
            <td>{data.type}</td>
            <td>{String(data.count).padStart(3, '0')}건</td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      blockScroll={false}
      classNames={{
        overlay: 'talkModalOverlay',
        modal: 'talkModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <h2>주문 발송 상세보기</h2>
          <h4>2024-01-08</h4>
          <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} type="radius" />
        </div>
      </Style>
    </Modal>
  );
};

export default OrderTalkModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }
  /* modalWrapper */
  .modalWrapper {
    height: 100%;
    padding: 8%;
    background: #fff;
    overflow: hidden;
  }

  h2 {
    text-align: left;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
  h4 {
    text-align: right;
    color: #a7a7a7;
    font-weight: 400;
    padding: 6px 0;
  }

  tr {
    color: #333333;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
  td {
    color: #333333;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
  td:nth-child(2) {
    font-weight: 400;
  }

  @media (max-width: 900px) {
    .modalWrapper {
      padding: 32px 4%;
    }
  }
`;
